import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setInitializedMap = (
  state: MapState,
  action: PayloadAction<MapState['initialized']>
) => {
  state.initialized = action.payload;
}